export const SectionCard = ({ title, right, children }) => (
  <div className="bg-white rounded-2xl shadow-sm border border-blue-50 p-2 flex flex-col h-full">
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-semibold text-slate-700">{title}</h2>
      {right}
    </div>
    <div className="flex-1">{children}</div>
  </div>
);